import { render, staticRenderFns } from "./ExportLogChat.vue?vue&type=template&id=39d163c2&scoped=true"
import script from "./ExportLogChat.vue?vue&type=script&lang=js"
export * from "./ExportLogChat.vue?vue&type=script&lang=js"
import style0 from "./ExportLogChat.vue?vue&type=style&index=0&id=39d163c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d163c2",
  null
  
)

export default component.exports